export enum AuthorizeNetPaymentTransactionStatus {
    Voidable = 0,
    Creditable = 1,
    Other = 2,
}
